import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';

export default {
  'navBar.lang': '语言',
  ...pages,
  ...menu,
  ...pwa,
};
